import React from "react"
import { Helmet } from "react-helmet"

const IndexPage = () => (
  <>
    <Helmet>
      <title>Privacy Policy | au et chiu Import Export</title>
      <link rel="canonical" href="https://auetchiu.com" />
    </Helmet>
    <div className="o-section o-grid">
      <div className="o-grid__item--center">
        <h1>Privacy Policy</h1>
        <p className="c-body-text c-text--privacy">This Privacy Policy describes how your personal information is collected, used, and shared when you visit auetchiu.com (the “Site”).</p>

        <h3 className="c-heading c-heading--privacy">PERSONAL INFORMATION WE COLLECT</h3>
        <p>When you submit information through the contact form, we collect the following information: name, email. We refer to this information as "Personal Information".</p>

        <h3 className="c-heading c-heading--privacy">HOW DO WE USE YOUR PERSONAL INFORMATION?</h3>
        <p>We use the Personal Information to communicate with and notify you.</p>

        <h3 className="c-heading c-heading--privacy">SHARING YOUR PERSONAL INFORMATION</h3>
        <p>We may share your Personal Information with third parties to help us use your Personal Information, as described above. Finally, we may also share your Personal Information to comply with applicable laws and regulations, to respond to a subpoena, search warrant or other lawful request for information we receive, or to otherwise protect our rights.</p>

        <h3 className="c-heading c-heading--privacy">DATA RETENTION</h3>
        <p>When you send info through the contact form, we will maintain your Information for our records unless and until you ask us to delete this information.</p>

        <h3 className="c-heading c-heading--privacy">CHANGES</h3>
        <p>We may update this privacy policy from time to time in order to reflect, for example, changes to our practices or for other operational, legal or regulatory reasons.</p>

        <h3 className="c-heading c-heading--privacy">CONTACT US</h3>
        <p>For more information about our privacy practices, if you have questions, or if you would like to make a complaint, please contact us through the form on the Contact page.</p>

      </div>
    </div>
  </>
)

export default IndexPage
